import { useContext } from "react";
import { TemplateContext } from "../layout";

export const useFreeShipping = () => {
  const [templateContext] = useContext(TemplateContext);
  return templateContext.freeShipping;
};
